// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"396":"06389b21","755":"4773d6a6","972":"a55d8dae"}[chunkId] + ".css";
};